import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { PersonelAvatarComponent } from '@/src/service/fikoyt-ui/src/lib/personel-avatar/personel-avatar.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

@Component({
  selector: 'personel-kart-sade',
  standalone: true,
  imports: [CommonModule, PersonelAvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ui text-center fluid pb-2">
      <div class="ui primary label mini"> Personel Tanımı </div>
    </div>
    <div class="sk" style="--sk-accent:#00b4d8">
      <personel-avatar [kullaniciId]="deger('kullaniciId')" [ad]="deger('ad')" [soyad]="deger('soyad')" [boyut]="48" />
      <div class="sk-icerik">
        <div class="sk-baslik">{{ tamAd() }}</div>
        @if (deger('unvan') || deger('gorev')) { <div class="sk-alt">{{ deger('unvan') || deger('gorev') }}</div> }
        @if (deger('departman')) { <span class="sk-chip">{{ deger('departman') }}</span> }
      </div>
      <div class="sk-sag">
        @if (deger('sicilNo')) { <span class="sk-alt">{{ deger('sicilNo') }}</span> }
      </div>
    </div>
  `,
})
export class PersonelKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  tamAd = computed(() => {
    const ad = this.deger('ad') || '';
    const soyad = this.deger('soyad') || '';
    return (ad + ' ' + soyad).trim() || 'Isimsiz';
  });
}
